import { isJudgeParty, type PartyType } from '@/lib/auth/session';
import { useInspections, useNcrs, useSafetyInspections, useTbm } from '@/lib/queries';
import { inspectionTodo, ncrTodo, safetyActionTodo, tbmTodoCount } from '@/lib/todo';
import type { Uuid } from '@/lib/types';

/**
 * 사이드바 「오늘」 묶음에 붙는 건수 — 메뉴 키 → 할 일 수.
 *
 * <p>새 API 를 만들지 않는다. 위젯이 이미 부르는 쿼리를 그대로 부르고, 세는 규칙도 위젯과 같은
 * 함수({@code lib/todo.ts})다. react-query 가 같은 키를 합쳐 주므로 요청은 늘지 않는다.
 *
 * <p>현장이 없으면({@code siteId === ''}) 아무것도 묻지 않는다 — 훅은 조건부로 부를 수 없어
 * {@code enabled} 로 끈다.
 */
export function useTodoCounts(siteId: Uuid, partyType: PartyType): Record<string, number> {
  // 판정하는 손 — 감리와 직원(DOC-87 §3-3). 위젯과 같은 축이다.
  const judge = isJudgeParty(partyType);
  const vendor = partyType === 'VENDOR';
  const enabled = siteId !== '';

  const inspections = useInspections(siteId, { enabled });
  const safetyInspections = useSafetyInspections(siteId, { enabled });
  const ncrs = useNcrs(siteId, { enabled });
  // TBM 서명은 협력사만 한다. 감리·직원에게는 「오늘」 묶음에 안전이 없다.
  const tbm = useTbm(siteId, { enabled: enabled && vendor });

  return {
    inspections: inspectionTodo(inspections.data ?? [], judge).length,
    'safety-inspections': safetyActionTodo(safetyInspections.data ?? [], judge).length,
    ncrs: ncrTodo(ncrs.data ?? [], judge).length,
    safety: vendor ? tbmTodoCount(tbm.data ?? []) : 0,
  };
}
